/**
 * Auth session hook
 * Single source of truth for user + profile + company + role
 * Eliminates sequential waterfall in Index.tsx and DashboardRouter
 */

import { useQuery } from "@tanstack/react-query";
import { authKeys, queryOptions } from "@/data/query-keys";
import { getCurrentUserWithProfileAndCompany } from "@/data/supabase/auth";

// Re-export types for convenience
export type { AuthSession, UserProfile, CompanyBasic } from "@/data/supabase/auth";

export const useAuthSession = () => {
  return useQuery({
    queryKey: authKeys.session(),
    queryFn: getCurrentUserWithProfileAndCompany,
    staleTime: queryOptions.auth.staleTime,
    gcTime: queryOptions.auth.gcTime,
    retry: queryOptions.auth.retry,
  });
};
